import { row, column } from 'helpers/styles/grid'
import { COLORS } from 'helpers/globals'

export default {
  buttons: {
    borderTop: '1px solid #ccc',
    paddingTop: '1.5rem',
    marginBottom: '2.5rem',
    '& button': {
      marginLeft: '0.5rem',
      fontSize: '1.4rem'
    }
  },
  saveButton: {
    transition: 'opacity 200ms linear',
    '&.disabled': {
      opacity: '0.5',
      cursor: 'not-allowed',
      '&:hover, &:focus': { background: COLORS.primary }
    }
  },
  cancelButton: {
    background: COLORS.quaternary,
    '&:hover': {
      background: COLORS.quaternaryHover
    }
  },
  buttonContainer: {
    float: 'right'
  },
  latLngContainer: {
    ...row
  },
  latlng: {
    ...column,
    '&:first-of-type': {
      marginRight: '3%'
    },
    transition: 'border 200ms linear, box-shadow 200ms linear',
    '&.invalid': {
      border: `1px solid ${COLORS.danger}`,
      boxShadow: `0 0 5px 0 ${COLORS.danger}`
    }
  },
  label: {
    marginTop: '1rem',
    '&:first-of-type': {
      marginTop: 0
    }
  },
  errorText: {
    display: 'flex',
    gap: '3%',
    color: 'red',
    margin: '.5rem 0 1rem 0',
    height: '2.5rem',
    fontSize: '1.4rem',
    '& span': { flex: '1 1 50%' }
  },
  errorTextFadeIn: {
    visibility: 'visible',
    opacity: 1,
    transition: 'visibility 0s linear 0s, opacity 200ms linear'
  },
  errorTextFadeOut: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 0s linear 200ms, opacity 200ms linear'
  }
}



// WEBPACK FOOTER //
// ./src/components/EditLocation/style.js